import { render, staticRenderFns } from "./OnlineClients.vue?vue&type=template&id=0fc90e4e&scoped=true"
import script from "./OnlineClients.vue?vue&type=script&lang=js"
export * from "./OnlineClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc90e4e",
  null
  
)

/* custom blocks */
import block0 from "./OnlineClients.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports